import React, { useEffect, useState } from "react";
import { BASE_URL, getApiUrl } from "../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [selectedSize, setSelectedSize] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeProduct, setActiveProduct] = useState(null);

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  // Fetch wishlist from API
  const fetchWishlist = async () => {
    try {
      const res = await fetch(getApiUrl("wishlist-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
      const data = await res.json();
      if (data.success) setWishlistItems(data.data || []);
    } catch (err) {
      console.error("Fetch Wishlist Error:", err);
      toast.error("Failed to load wishlist ❗");
    } finally {
      setLoading(false);
    }
  };

  // Remove item from wishlist
  const removeWishlistItem = async (wishlistId) => {
    try {
      const res = await fetch(getApiUrl("wishlist-delete"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ wishlistId }),
      });

      const data = await res.json();
      if (data.success) {
        setWishlistItems((prev) =>
          prev.filter((item) => item._id !== wishlistId)
        );
        toast.success("Removed from wishlist ✅");
      }
    } catch (err) {
      console.error("Remove Wishlist Error:", err);
      toast.error("Failed to remove ❗");
    }
  };

  // Add to cart
  const handleAddToCart = async () => {
    if (!selectedSize) return toast.warning("Select size");
    const userId = localStorage.getItem("userId");

    const res = await fetch(getApiUrl("cart-add"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId,
        productId: activeProduct._id,
        selectedSize,
        quantity: 1,
      }),
    });

    const data = await res.json();
    if (data.success) {
      toast.success("Added to Cart ✅");
      setShowModal(false);
      setSelectedSize(null);
      navigate("/bskian-cart");
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  if (loading) return <h5 className="text-center py-5">Loading Wishlist...</h5>;

  const validItems = wishlistItems.filter((item) => item.productId);

  if (validItems.length === 0)
    return <h5 className="text-center py-5">Wishlist is empty ❤️</h5>;

  // Pagination
  const totalPages = Math.ceil(validItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = validItems.slice(startIndex, startIndex + itemsPerPage);
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="container py-5">
      <h5 className="mb-4 fw-semibold">My Wishlist</h5>

      {currentItems.map((item) => {
        const product = item.productId;
        const availableSizes = product.sizes
          ? Object.keys(product.sizes).filter((s) => product.sizes[s] > 0)
          : [];

        // Open product detail page
        const openProductDetail = () => {
          if (!product.slugUrl)
            return toast.error("Product link not available ❗");
          window.open(`${window.location.origin}/${product.slugUrl}`, "_blank");
        };

        return (
          <div
            key={item._id}
            className="card p-3 mb-3 shadow-sm border-0 d-flex flex-row align-items-center"
          >
            {/* Image */}
            <div
              style={{ width: "120px", marginRight: "15px", cursor: "pointer" }}
              onClick={openProductDetail}
            >
              <img
                src={
                  product.mainImage
                    ? `${BASE_URL}${product.mainImage}`
                    : "/no-image.png"
                }
                alt={product.productName || ""}
                style={{ width: "100%", height: "100px", objectFit: "cover" }}
              />
            </div>

            {/* Product info */}
            <div
              className="flex-grow-1"
              onClick={openProductDetail}
              style={{ cursor: "pointer" }}
            >
              <h6>{product.productName}</h6>
              <p className="mb-1">
                Price: ₹{product.price}{" "}
                {product.originalPrice && (
                  <span className="text-muted text-decoration-line-through ms-2">
                    ₹{product.originalPrice}
                  </span>
                )}
              </p>
              <p className="mb-1 text-muted">Stock: {product.totalProducts}</p>
            </div>

            {/* Actions */}
            <div className="d-flex flex-column align-items-end">
              <button
                className="btn btn-outline-primary btn-sm mb-1"
                onClick={() => {
                  setActiveProduct(product);
                  setShowModal(true);
                }}
              >
                <i className="fa-solid fa-cart-shopping"></i>
              </button>
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => removeWishlistItem(item._id)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>

           
            {showModal && activeProduct?._id === product._id && (
              <div
                className="modal fade show"
                style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-sm modal-dialog-centered">
                  <div className="modal-content rounded-4">
                    <div className="modal-header">
                      <h5 className="modal-title fw-bold">Select Size</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body d-flex flex-wrap justify-content-center">
                      {availableSizes.length > 0 ? (
                        availableSizes.map((size) => (
                          <button
                            key={size}
                            type="button"
                            className={`btn btn-outline-primary m-1 ${
                              selectedSize === size ? "active" : ""
                            }`}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size} ({product.sizes[size]})
                          </button>
                        ))
                      ) : (
                        <p className="text-danger">Out of stock</p>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm w-100"
                        disabled={!selectedSize}
                        onClick={handleAddToCart}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

    
      <div className="d-flex justify-content-center mt-3">
        <button
          className="btn btn-outline-primary me-2"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Prev
        </button>

        <span className="align-self-center mx-2">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="btn btn-outline-primary ms-2"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Wishlist;
